import React from "react";
import { 
  FaShieldAlt, 
  FaStar, 
  FaCheckCircle, 
  FaClock, 
  FaUsers, 
  FaTrophy,
  FaHandshake,
  FaGlobe,
  FaRocket,
  FaMedal,
  FaUserSecret,
  FaBuilding
} from "react-icons/fa";
import "../styles/Marquee.css";

const Marquee = ({ variant = "default" }) => {
  // Default marquee items
  const defaultItems = [
    { text: "5000+ Cases Solved", icon: <FaCheckCircle /> },
    { text: "98% Success Rate", icon: <FaStar /> },
    { text: "15+ Years Experience", icon: <FaClock /> },
    { text: "50+ Expert Detectives", icon: <FaUsers /> },
    { text: "24/7 Emergency Support", icon: <FaShieldAlt /> },
    { text: "Pan India Network", icon: <FaGlobe /> },
    { text: "100% Confidential", icon: <FaHandshake /> },
    { text: "Court-Admissible Evidence", icon: <FaMedal /> },
      { text: "5000+ Cases Solved", icon: <FaCheckCircle /> },
    { text: "98% Success Rate", icon: <FaStar /> },
    { text: "15+ Years Experience", icon: <FaClock /> },
    { text: "50+ Expert Detectives", icon: <FaUsers /> },
    { text: "24/7 Emergency Support", icon: <FaShieldAlt /> },
    { text: "Pan India Network", icon: <FaGlobe /> },
    { text: "100% Confidential", icon: <FaHandshake /> },
    { text: "Court-Admissible Evidence", icon: <FaMedal /> },
  ];

  // Achievement marquee items
  const achievementItems = [
    { text: "India's Most Trusted Detective Agency", icon: <FaTrophy /> },
    { text: "ISO 9001:2015 Certified", icon: <FaMedal /> },
    { text: "Government Licensed", icon: <FaShieldAlt /> },
    { text: "5000+ Happy Clients", icon: <FaUsers /> },
    { text: "98% Client Satisfaction", icon: <FaStar /> },
    { text: "Award Winning Service", icon: <FaRocket /> },
    { text: "India's Most Trusted Detective Agency", icon: <FaTrophy /> },
    { text: "ISO 9001:2015 Certified", icon: <FaMedal /> },
    { text: "Government Licensed", icon: <FaShieldAlt /> },
    { text: "5000+ Happy Clients", icon: <FaUsers /> },
    { text: "98% Client Satisfaction", icon: <FaStar /> },
    { text: "Award Winning Service", icon: <FaRocket /> },
  ];

  // Service marquee items
  const serviceItems = [
    { text: "Personal Investigation", icon: <FaUserSecret /> },
    { text: "Corporate Investigation", icon: <FaBuilding /> },
    { text: "NRI Services", icon: <FaGlobe /> },
    { text: "Cyber Forensics", icon: <FaShieldAlt /> },
    { text: "Background Verification", icon: <FaCheckCircle /> },
    { text: "Due Diligence", icon: <FaHandshake /> },
     { text: "Personal Investigation", icon: <FaUserSecret /> },
    { text: "Corporate Investigation", icon: <FaBuilding /> },
    { text: "NRI Services", icon: <FaGlobe /> },
    { text: "Cyber Forensics", icon: <FaShieldAlt /> },
    { text: "Background Verification", icon: <FaCheckCircle /> },
    { text: "Due Diligence", icon: <FaHandshake /> },
  ];

  const getItems = () => {
    switch (variant) {
      case "achievements":
        return achievementItems;
      case "services":
        return serviceItems;
      default:
        return defaultItems;
    }
  };

  const items = getItems();

  return (
    <div className={`marquee-container marquee-${variant}`}>
      <div className="marquee-wrapper">
        <div className="marquee-content">
          {/* First set of items */}
          {items.map((item, index) => (
            <div key={`first-${index}`} className="marquee-item">
              <span className="marquee-icon">{item.icon}</span>
              <span className="marquee-text">{item.text}</span>
            </div>
          ))}
          {/* Duplicate set for seamless loop */}
          {items.map((item, index) => (
            <div key={`second-${index}`} className="marquee-item">
              <span className="marquee-icon">{item.icon}</span>
              <span className="marquee-text">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Marquee;